import React, { Fragment, useState, useEffect } from "react";
import announcementBarImg from "../../../src/assests/images/announcementBar.png";
import Marquee from "react-fast-marquee";

const AnnpuncementBar = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 991);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 991);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <Fragment>
      <div className="announcementBar ">
        <div className="announcementBar-info container1500">
          <img src={announcementBarImg} alt="img" />

          {isMobile ? (
            <Marquee speed={30} delay={2}>
              <p>
              Claim Solutions Scotland Ltd T/A Housing Disrepair Heroes is a Claims Management Company (CMC). You do not have to use a Claims Management Company or Solicitor to pursue a claim. You can claim for free, without using a claims management company, first to your landlord or to the Housing Ombudsman Service (England)/Public Services Ombudsman (Scotland & Wales). &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              </p>
            </Marquee>
          ) : (
            <p>
            Claim Solutions Scotland Ltd T/A Housing Disrepair Heroes is a Claims Management Company (CMC). You do not have to use a Claims Management Company or Solicitor to pursue a claim. You can claim for free, without using a claims management company, first to your landlord or to the Housing Ombudsman Service (England)/Public Services Ombudsman (Scotland & Wales).
            </p>
          )}
        </div>
      </div>
    </Fragment>
  );
};
export default AnnpuncementBar;
